import React, {Component} from 'react';
import {Helmet} from 'react-helmet';
const { connect } = require('react-redux');

import HeaderContacts from '../components/contacts/HeaderContacts';
import FormContacts from '../components/contacts/FormContacts';
import Footer from '../components/Footer';

import 'sass/contacts.scss';
import {dt} from 'l10n';

class Contacts extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {

    }

    render() {
        let {currentUser} = this.props;

        return (
            <div id="wrapper" className="ui-kit-base">
                <Helmet>
                    <title>{dt('meta', 'Contact BobTV page')}</title>
                    <meta name="description"
                          content={dt('meta', 'Contact Bob for all matters relating to the webcam chat BobTV. Video Chat exhibitions and meetings between adults.')}
                    />
                </Helmet>

                <HeaderContacts />
                <FormContacts currentUser={currentUser}/>
                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser
    }),({
    })
)(Contacts)


// WEBPACK FOOTER //
// ./src/containers/Contacts.js